/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_CmdInputs */

const en_dr_proof_cmd = /** @type {(inputs: Dr_Proof_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task verify`)
};

const id_dr_proof_cmd = /** @type {(inputs: Dr_Proof_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task verify`)
};

/**
* | output |
* | --- |
* | "bystep task verify" |
*
* @param {Dr_Proof_CmdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_cmd = /** @type {((inputs?: Dr_Proof_CmdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_CmdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_cmd(inputs)
	return en_dr_proof_cmd(inputs)
});